import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./WebsitePopup.css";

const API = "https://spst.in/myapp/api/";

/*
|--------------------------------------------------------------------------
| Convert stored file path into usable URL
|--------------------------------------------------------------------------
*/

const getFileUrl = (target) => {
    if (!target) {
        return "";
    }

    let value = String(target).trim();

    // Already complete URL
    if (
        value.startsWith("http://") ||
        value.startsWith("https://")
    ) {
        return value;
    }

    // /myapp/...
    if (value.startsWith("/myapp/")) {
        return "https://spst.in" + value;
    }

    // /uploads/...
    if (value.startsWith("/uploads/")) {
        return API + value.substring(1);
    }

    // uploads/...
    if (value.startsWith("uploads/")) {
        return API + value;
    }

    // Just in case database contains another relative path
    return API + value;
};


function WebsitePopup() {

    const [popups, setPopups] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showPopup, setShowPopup] = useState(false);

    /*
    |--------------------------------------------------------------------------
    | React Router
    |--------------------------------------------------------------------------
    */

    const navigate = useNavigate();


    /*
    |--------------------------------------------------------------------------
    | Load active popups
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        axios
            .get(API + "popup_active.php")

            .then((response) => {

                console.log(
                    "===================================="
                );

                console.log(
                    "POPUP API RESPONSE:",
                    response.data
                );

                console.log(
                    "===================================="
                );


                if (
                    response.data.success &&
                    Array.isArray(response.data.data)
                ) {

                    const activePopups =
                        response.data.data;

                    console.log(
                        "ACTIVE POPUPS:",
                        activePopups
                    );


                    setPopups(activePopups);


                    if (
                        activePopups.length > 0
                    ) {

                        setCurrentIndex(0);

                        setShowPopup(true);

                    }

                }

            })

            .catch((error) => {

                console.error(
                    "POPUP ERROR:",
                    error
                );

            });

    }, []);


    /*
    |--------------------------------------------------------------------------
    | No popup
    |--------------------------------------------------------------------------
    */

    if (
        !showPopup ||
        popups.length === 0
    ) {

        return null;

    }


    /*
    |--------------------------------------------------------------------------
    | Current popup
    |--------------------------------------------------------------------------
    */

    const currentPopup =
        popups[currentIndex];


    /*
    |--------------------------------------------------------------------------
    | Main popup image
    |--------------------------------------------------------------------------
    */

    const imageUrl =
        getFileUrl(
            currentPopup.image
        );


    /*
    |--------------------------------------------------------------------------
    | Popup type
    |--------------------------------------------------------------------------
    */

    const popupType =
        String(
            currentPopup.popup_type || "none"
        )
            .trim()
            .toLowerCase();


    /*
    |--------------------------------------------------------------------------
    | Popup target
    |
    | We support popup_target.
    |
    | Also support target_file / target_value
    | in case your existing database/API uses those names.
    |--------------------------------------------------------------------------
    */

    const popupTarget =
        currentPopup.popup_target ||
        currentPopup.target_file ||
        currentPopup.target_value ||
        "";


    const cleanTarget =
        String(popupTarget).trim();


    /*
    |--------------------------------------------------------------------------
    | Does popup have an action?
    |--------------------------------------------------------------------------
    */

    const hasAction =
        popupType !== "none" &&
        popupType !== "" &&
        cleanTarget !== "";


    /*
    |--------------------------------------------------------------------------
    | DEBUG
    |--------------------------------------------------------------------------
    */

    console.log(
        "CURRENT POPUP:",
        currentPopup
    );

    console.log(
        "POPUP TYPE:",
        popupType
    );

    console.log(
        "POPUP TARGET:",
        cleanTarget
    );

    console.log(
        "MAIN IMAGE URL:",
        imageUrl
    );


    /*
    |--------------------------------------------------------------------------
    | Handle popup image click
    |--------------------------------------------------------------------------
    */

    const handlePopupClick = () => {

        console.log(
            "===================================="
        );

        console.log(
            "POPUP IMAGE CLICKED"
        );

        console.log(
            "TYPE:",
            popupType
        );

        console.log(
            "TARGET:",
            cleanTarget
        );

        console.log(
            "===================================="
        );


        /*
        |--------------------------------------------------------------------------
        | NONE
        |--------------------------------------------------------------------------
        */

        if (
            popupType === "none" ||
            popupType === "" ||
            !cleanTarget
        ) {

            console.log(
                "Popup has no additional action."
            );

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | IMAGE
        |--------------------------------------------------------------------------
        */

        if (
            popupType === "image"
        ) {

            const url =
                getFileUrl(
                    cleanTarget
                );


            console.log(
                "Opening IMAGE:",
                url
            );


            if (url) {

                window.open(
                    url,
                    "_blank"
                );

            }

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | PDF
        |--------------------------------------------------------------------------
        */

        if (
            popupType === "pdf"
        ) {

            const url =
                getFileUrl(
                    cleanTarget
                );


            console.log(
                "Opening PDF:",
                url
            );


            if (url) {

                window.open(
                    url,
                    "_blank"
                );

            }

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | EXISTING COMPONENT / REACT PAGE
        |--------------------------------------------------------------------------
        */

        if (
            popupType === "component" ||
            popupType === "existing"
        ) {

            let route =
                cleanTarget;


            console.log(
                "Navigating to:",
                route
            );


            /*
            |--------------------------------------------------------------------------
            | Example:
            |
            | /booking
            | /donation
            | /gallery
            | /contact
            |--------------------------------------------------------------------------
            */

            if (
                !route.startsWith("/")
            ) {

                route =
                    "/" + route;

            }


            /*
            |--------------------------------------------------------------------------
            | Hide popup before navigation
            |--------------------------------------------------------------------------
            */

            setShowPopup(false);


            /*
            |--------------------------------------------------------------------------
            | React Router navigation
            |--------------------------------------------------------------------------
            */

            navigate(route);


            return;

        }


        /*
        |--------------------------------------------------------------------------
        | EXTERNAL URL
        |--------------------------------------------------------------------------
        */

        if (
            popupType === "external" ||
            popupType === "url"
        ) {

            let url =
                cleanTarget;


            /*
            |--------------------------------------------------------------------------
            | Add https:// when required
            |--------------------------------------------------------------------------
            */

            if (
                !url.startsWith("http://") &&
                !url.startsWith("https://")
            ) {

                url =
                    "https://" + url;

            }


            console.log(
                "Opening EXTERNAL URL:",
                url
            );


            window.open(
                url,
                "_blank",
                "noopener,noreferrer"
            );


            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Unknown type
        |--------------------------------------------------------------------------
        */

        console.warn(
            "Unknown popup type:",
            popupType
        );

    };


    /*
    |--------------------------------------------------------------------------
    | NEXT POPUP
    |--------------------------------------------------------------------------
    */

    const nextPopup = () => {

        if (
            currentIndex <
            popups.length - 1
        ) {

            setCurrentIndex(
                (prevIndex) =>
                    prevIndex + 1
            );

        } else {

            /*
            | Last popup
            | Close popup window
            */

            setShowPopup(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | PREVIOUS POPUP
    |--------------------------------------------------------------------------
    */

    const previousPopup = () => {

        if (
            currentIndex > 0
        ) {

            setCurrentIndex(
                (prevIndex) =>
                    prevIndex - 1
            );

        }

    };


    /*
    |--------------------------------------------------------------------------
    | CLOSE BUTTON
    |
    | IMPORTANT:
    |
    | Clicking × behaves like NEXT.
    |
    | Popup 1 → × → Popup 2
    | Popup 2 → × → Popup 3
    | Popup 3 → × → Close
    |--------------------------------------------------------------------------
    */

    const closePopup = () => {

        if (
            currentIndex <
            popups.length - 1
        ) {

            setCurrentIndex(
                (prevIndex) =>
                    prevIndex + 1
            );

        } else {

            /*
            | Last active popup
            | Actually close the popup
            */

            setShowPopup(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | RENDER
    |--------------------------------------------------------------------------
    */

    return (

        <div className="website-popup-overlay">

            <div className="website-popup">


                {/* ================================================= */}
                {/* CLOSE BUTTON */}
                {/* ================================================= */}

                <button
                    type="button"
                    className="website-popup-close"
                    onClick={closePopup}
                    aria-label={
                        currentIndex <
                        popups.length - 1
                            ? "Next popup"
                            : "Close popup"
                    }
                >
                    ×
                </button>


                {/* ================================================= */}
                {/* POPUP IMAGE */}
                {/* ================================================= */}

                <div
                    className={
                        hasAction
                            ? "popup-clickable"
                            : "popup-not-clickable"
                    }

                    onClick={
                        hasAction
                            ? handlePopupClick
                            : undefined
                    }

                    title={
                        hasAction
                            ? "Click to open"
                            : ""
                    }
                >

                    <img
                        src={imageUrl}
                        alt={
                            currentPopup.title ||
                            "Website Popup"
                        }
                        className="website-popup-image"
                    />

                </div>


                {/* ================================================= */}
                {/* COUNTER */}
                {/* ================================================= */}

                {popups.length > 1 && (

                    <div className="popup-counter">

                        {currentIndex + 1}
                        {" / "}
                        {popups.length}

                    </div>

                )}


                {/* ================================================= */}
                {/* PREVIOUS BUTTON - LEFT */}
                {/* ================================================= */}

                {popups.length > 1 &&
                    currentIndex > 0 && (

                    <button
                        type="button"
                        className="popup-previous"
                        onClick={previousPopup}
                        aria-label="Previous popup"
                    >

                        <span className="popup-arrow">
                            ‹
                        </span>

                        <span>
                            Previous
                        </span>

                    </button>

                )}


                {/* ================================================= */}
                {/* NEXT BUTTON - RIGHT */}
                {/* ================================================= */}

                {popups.length > 1 && (

                    <button
                        type="button"
                        className="popup-next"
                        onClick={nextPopup}
                        aria-label={
                            currentIndex <
                            popups.length - 1
                                ? "Next popup"
                                : "Close popup"
                        }
                    >

                        <span>
                            {currentIndex <
                            popups.length - 1
                                ? "Next"
                                : "Close"}
                        </span>

                        {currentIndex <
                        popups.length - 1 && (

                            <span className="popup-arrow">
                                ›
                            </span>

                        )}

                    </button>

                )}


            </div>

        </div>

    );

}

export default WebsitePopup;